import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { UnitofmeasurementcultureListService } from '../../service/unitofmeasurementculture-list/unitofmeasurementculture-list.service';

@Component({
	selector: 'app-unitofmeasurementculture-list',
	templateUrl: './unitofmeasurementculture-list.component.html',
	providers: [
		UnitofmeasurementcultureListService,
		HttpModule
	]
})
export class UnitofmeasurementcultureListComponent implements OnInit {

	private token;
	public units: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	unit: FormGroup;

	constructor(fb: FormBuilder, private unitofmeasurementcultureListService: UnitofmeasurementcultureListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.unit = fb.group({
			'Nome': '',
			'Sigla': '',
			'Status': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchUnit(this.unit.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchUnit(this.unit.value, this.currentPage, false);
	}

	searchUnit(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.unitofmeasurementcultureListService.searchUnit(this.token, value.Nome, value.Status, value.Sigla, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.units = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchUnit(this.unit.value, $event, false);
	}

}


// WEBPACK FOOTER //
// ./src/app/unitofmeasurementculture/component/unitofmeasurementculture-list/unitofmeasurementculture-list.component.ts